/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefetchContainer_shippingFilters$ref: FragmentReference;
export type SbSharedRefetchContainer_shippingFilters = $ReadOnlyArray<{|
  +totalCount: ?number,
  +$refType: SbSharedRefetchContainer_shippingFilters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefetchContainer_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd5ad44746e573a35fa3db0693e7d384d';
module.exports = node;
